// متغير لحفظ معرف المستخدم الحالي
import { DEFAULT_IMAGE_URL } from "../config/apiConfig";

let currentUserId = null;

// دالة لتعيين المستخدم الحالي
export const setCurrentUser = (userId) => {
  currentUserId = userId;
  // ملاحظة: مسح بيانات الضيف بيحصل فقط بعد نقلها فعليًا لحساب مسجل
  // (جوه transferGuestDataToUser) مش هنا، عشان منمسحش سلة أي زائر عادي
  // كل ما يفتح صفحة جديدة وهو لسه مش مسجل دخول.
};

// دالة للحصول على المستخدم الحالي
export const getCurrentUser = () => {
  return currentUserId;
};

// دالة للحصول على مفتاح localStorage مع معرف المستخدم
const getStorageKey = (key) => {
  if (currentUserId) {
    return `${key}_user_${currentUserId}`;
  }
  // للمستخدمين غير المسجلين، استخدم مفتاح مؤقت
  return `${key}_guest`;
};

// دالة لتشغيل الأحداث المخصصة
const triggerStorageEvent = (type) => {
  // تشغيل حدث مخصص لتحديث المكونات
  window.dispatchEvent(new CustomEvent(`${type}Updated`));

  // تشغيل حدث storage للتبويبات الأخرى
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: getStorageKey(type),
      newValue: localStorage.getItem(getStorageKey(type)),
      url: window.location.href,
    })
  );
};

// دالة لمسح بيانات الضيوف
const clearGuestData = () => {
  try {
    localStorage.removeItem("cart_guest");
    localStorage.removeItem("favorites_guest");
  } catch (error) {
    console.error("Error clearing guest data:", error);
  }
};

// دالة لنقل البيانات من الضيف إلى المستخدم المسجل
export const transferGuestDataToUser = (userId) => {
  try {
    // نقل بيانات السلة
    const guestCart = localStorage.getItem("cart_guest");
    if (guestCart) {
      localStorage.setItem(`cart_user_${userId}`, guestCart);
    }

    // نقل بيانات المفضلة
    const guestFavorites = localStorage.getItem("favorites_guest");
    if (guestFavorites) {
      localStorage.setItem(`favorites_user_${userId}`, guestFavorites);
    }

    // مسح بيانات الضيف
    clearGuestData();

    // تعيين المستخدم الحالي
    setCurrentUser(userId);

    // تشغيل الأحداث لتحديث الواجهة
    triggerStorageEvent("cart");
    triggerStorageEvent("favorites");

    return true;
  } catch (error) {
    console.error("Error transferring guest data:", error);
    return false;
  }
};

// دالة لتسجيل الخروج ومسح بيانات المستخدم
export const logout = () => {
  if (currentUserId) {
    // اختياري: مسح بيانات المستخدم أو الاحتفاظ بها
    // clearUserData(currentUserId);

    currentUserId = null;
  }
};

// دالة لمسح بيانات مستخدم معين (اختيارية)
export const clearUserData = (userId) => {
  try {
    localStorage.removeItem(`cart_user_${userId}`);
    localStorage.removeItem(`favorites_user_${userId}`);
    return true;
  } catch (error) {
    console.error("Error clearing user data:", error);
    return false;
  }
};

// المفضلة (Favorites)
export const getFavorites = () => {
  try {
    const storageKey = getStorageKey("favorites");
    const favorites = localStorage.getItem(storageKey);
    return favorites ? JSON.parse(favorites) : [];
  } catch (error) {
    console.error("Error getting favorites from localStorage:", error);
    return [];
  }
};

export const addToFavorites = (product) => {
  try {
    const favorites = getFavorites();
    const existingIndex = favorites.findIndex(
      (item) => item.product_id === product.product_id
    );

    if (existingIndex === -1) {
      // إضافة منتج جديد للمفضلة
      favorites.push({
        id: Date.now(), // معرف فريد
        product_id: product.product_id,
        variation_id: product.variation_id || null,
        item_id: product.product_id,
        item_name: product.name,
        price: product.price,
        discount: product.default_sales_discount || 0,
        icon:
          product.image_url || DEFAULT_IMAGE_URL,
        stock: product.stock,
        original_price: product.price,
        added_at: new Date().toISOString(),
      });

      const storageKey = getStorageKey("favorites");
      localStorage.setItem(storageKey, JSON.stringify(favorites));
      triggerStorageEvent("favorites"); // تشغيل الحدث
      return true; // تمت الإضافة
    } else {
      // إزالة من المفضلة إذا كان موجود
      favorites.splice(existingIndex, 1);
      const storageKey = getStorageKey("favorites");
      localStorage.setItem(storageKey, JSON.stringify(favorites));
      triggerStorageEvent("favorites"); // تشغيل الحدث
      return false; // تمت الإزالة
    }
  } catch (error) {
    console.error("Error managing favorites in localStorage:", error);
    return false;
  }
};

export const removeFromFavorites = (productId) => {
  try {
    const favorites = getFavorites();
    const filteredFavorites = favorites.filter(
      (item) => item.product_id !== productId
    );
    const storageKey = getStorageKey("favorites");
    localStorage.setItem(storageKey, JSON.stringify(filteredFavorites));
    triggerStorageEvent("favorites"); // تشغيل الحدث
    return true;
  } catch (error) {
    console.error("Error removing from favorites:", error);
    return false;
  }
};

export const isFavorite = (productId) => {
  const favorites = getFavorites();
  return favorites.some((item) => item.product_id === productId);
};

export const getFavoritesCount = () => {
  const favorites = getFavorites();
  return favorites.length;
};

export const clearFavorites = () => {
  try {
    const storageKey = getStorageKey("favorites");
    localStorage.removeItem(storageKey);
    triggerStorageEvent("favorites"); // تشغيل الحدث
    return true;
  } catch (error) {
    console.error("Error clearing favorites:", error);
    return false;
  }
};

// السلة (Cart)
export const getCart = () => {
  try {
    const storageKey = getStorageKey("cart");
    const cart = localStorage.getItem(storageKey);
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error("Error getting cart from localStorage:", error);
    return [];
  }
};

export const addToCart = (product, quantity = 1) => {
  try {
    const cart = getCart();
    const existingIndex = cart.findIndex(
      (item) => item.product_id === product.product_id
    );

    // التحقق من المخزون المتاح
    const availableStock = parseFloat(product.stock || 0);
    if (availableStock <= 0) {
      console.warn("Product out of stock");
      return false;
    }

    if (existingIndex !== -1) {
      // المنتج موجود، زيادة الكمية
      const newQuantity = cart[existingIndex].count + quantity;

      // التحقق من عدم تجاوز المخزون
      if (newQuantity > availableStock) {
        console.warn(
          `Cannot add more items. Available stock: ${availableStock}`
        );
        return false;
      }

      cart[existingIndex].count = newQuantity;
      cart[existingIndex].price = (
        parseFloat(cart[existingIndex].unit_price) * newQuantity
      ).toFixed(2);
      cart[existingIndex].updated_at = new Date().toISOString();
    } else {
      // منتج جديد
      if (quantity > availableStock) {
        console.warn(
          `Cannot add ${quantity} items. Available stock: ${availableStock}`
        );
        return false;
      }

      const discountedPrice = calculateDiscountedPrice(
        product.price,
        product.default_sales_discount || 0
      );

      cart.push({
        id: Date.now(),
        product_id: product.product_id,
        variation_id: product.variation_id || null,
        item_id: product.product_id,
        item_name: product.name,
        count: quantity,
        unit_price: parseFloat(discountedPrice).toFixed(2),
        price: (parseFloat(discountedPrice) * quantity).toFixed(2),
        icon:
          product.image_url || DEFAULT_IMAGE_URL,
        stock: product.stock,
        original_price: product.price,
        discount: product.default_sales_discount || 0,
        added_at: new Date().toISOString(),
      });
    }

    const storageKey = getStorageKey("cart");
    localStorage.setItem(storageKey, JSON.stringify(cart));
    triggerStorageEvent("cart"); // تشغيل الحدث
    return true;
  } catch (error) {
    console.error("Error adding to cart:", error);
    return false;
  }
};

export const removeFromCart = (productId) => {
  try {
    const cart = getCart();
    const filteredCart = cart.filter((item) => item.product_id !== productId);
    const storageKey = getStorageKey("cart");
    localStorage.setItem(storageKey, JSON.stringify(filteredCart));
    triggerStorageEvent("cart"); // تشغيل الحدث
    return true;
  } catch (error) {
    console.error("Error removing from cart:", error);
    return false;
  }
};

export const updateCartItemQuantity = (productId, quantity) => {
  try {
    const cart = getCart();
    const itemIndex = cart.findIndex((item) => item.product_id === productId);

    if (itemIndex !== -1) {
      const item = cart[itemIndex];
      const availableStock = parseFloat(item.stock || 0);

      if (quantity <= 0) {
        // إزالة العنصر إذا كانت الكمية صفر أو أقل
        cart.splice(itemIndex, 1);
      } else if (quantity > availableStock) {
        // التحقق من عدم تجاوز المخزون
        console.warn(
          `Cannot update quantity to ${quantity}. Available stock: ${availableStock}`
        );
        return false;
      } else {
        // تحديث الكمية والسعر
        cart[itemIndex].count = quantity;
        cart[itemIndex].price = (
          parseFloat(cart[itemIndex].unit_price) * quantity
        ).toFixed(2);
        cart[itemIndex].updated_at = new Date().toISOString();
      }

      const storageKey = getStorageKey("cart");
      localStorage.setItem(storageKey, JSON.stringify(cart));
      triggerStorageEvent("cart"); // تشغيل الحدث
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error updating cart item quantity:", error);
    return false;
  }
};

export const getCartTotal = () => {
  try {
    const cart = getCart();
    return cart
      .reduce((total, item) => total + parseFloat(item.price || 0), 0)
      .toFixed(2);
  } catch (error) {
    console.error("Error calculating cart total:", error);
    return "0.00";
  }
};

export const getCartItemsCount = () => {
  try {
    const cart = getCart();
    // FIX: كان بيرجع cart.length (عدد المنتجات المختلفة بس)،
    // فلو عندك منتج واحد بكمية 3 كان بيظهر "1" في أيقونة السلة.
    // دلوقتي بيجمع كل الكميات (count) الفعلية عشان يبقى الرقم مطابق
    // لعدد القطع الحقيقي في السلة.
    return cart.reduce((total, item) => total + (parseInt(item.count) || 0), 0);
  } catch (error) {
    console.error("Error getting cart items count:", error);
    return 0;
  }
};

export const getCartItemByProductId = (productId) => {
  try {
    const cart = getCart();
    return cart.find((item) => item.product_id === productId) || null;
  } catch (error) {
    console.error("Error getting cart item by product ID:", error);
    return null;
  }
};

export const isInCart = (productId) => {
  const cart = getCart();
  return cart.some((item) => item.product_id === productId);
};

export const clearCart = () => {
  try {
    const storageKey = getStorageKey("cart");
    localStorage.removeItem(storageKey);
    triggerStorageEvent("cart"); // تشغيل الحدث
    return true;
  } catch (error) {
    console.error("Error clearing cart:", error);
    return false;
  }
};

// Helper function لحساب السعر بعد الخصم
export const calculateDiscountedPrice = (price, discount) => {
  try {
    const originalPrice = parseFloat(price || 0);
    const discountPercent = parseFloat(discount || 0);

    if (discountPercent <= 0) {
      return originalPrice.toFixed(2);
    }

    const discountedPrice =
      originalPrice - (originalPrice * discountPercent) / 100;
    return Math.max(0, discountedPrice).toFixed(2);
  } catch (error) {
    console.error("Error calculating discounted price:", error);
    return parseFloat(price || 0).toFixed(2);
  }
};

// Helper function للحصول على معلومات المنتج من المفضلة أو السلة
export const getProductInfo = (productId) => {
  const cartItem = getCartItemByProductId(productId);
  const favorites = getFavorites();
  const favoriteItem = favorites.find((item) => item.product_id === productId);

  return {
    inCart: !!cartItem,
    inFavorites: !!favoriteItem,
    cartQuantity: cartItem ? cartItem.count : 0,
    cartItem: cartItem,
    favoriteItem: favoriteItem,
  };
};

// Helper function لتنظيف البيانات المنتهية الصلاحية (اختيارية)
export const cleanupExpiredData = (expiryDays = 30) => {
  try {
    const expiryTime = Date.now() - expiryDays * 24 * 60 * 60 * 1000;

    // تنظيف السلة
    const cart = getCart();
    const validCartItems = cart.filter((item) => {
      const addedTime = item.added_at
        ? new Date(item.added_at).getTime()
        : Date.now();
      return addedTime > expiryTime;
    });

    if (validCartItems.length !== cart.length) {
      const storageKey = getStorageKey("cart");
      localStorage.setItem(storageKey, JSON.stringify(validCartItems));
      triggerStorageEvent("cart");
    }

    // تنظيف المفضلة
    const favorites = getFavorites();
    const validFavorites = favorites.filter((item) => {
      const addedTime = item.added_at
        ? new Date(item.added_at).getTime()
        : Date.now();
      return addedTime > expiryTime;
    });

    if (validFavorites.length !== favorites.length) {
      const storageKey = getStorageKey("favorites");
      localStorage.setItem(storageKey, JSON.stringify(validFavorites));
      triggerStorageEvent("favorites");
    }

    return true;
  } catch (error) {
    console.error("Error cleaning up expired data:", error);
    return false;
  }
};

// لعمل الاوردرات

// دالة لتحضير بيانات الطلب من localStorage
export const prepareOrderData = (contactId, shippingInfo) => {
  try {
    // الحصول على بيانات السلة
    const cart = getCart();
    // const cartTotal = parseFloat(getCartTotal());
    // const shippingCharges = parseFloat(shippingInfo.shipping_charges || 0);
    if (!cart || cart.length === 0) {
      throw new Error("السلة فارغة");
    }

    // تحضير بيانات المنتجات
    // مهم جداً: الباك اند بيتوقع variation_id مش product_id في الحقل "id"
    // (ده اللي كان بيكسر مطابقة العروض وأي منطق تاني مبني على الـ variation الصح)
    const products = cart.map((item) => {
      if (!item.variation_id) {
        console.warn(
          "cart item missing variation_id, falling back to product_id:",
          item
        );
      }
      return {
        id: parseInt(item.variation_id || item.product_id),
        quantity: parseInt(item.count),
        price: parseFloat(item.unit_price),
      };
    });

    // تحضير بيانات الطلب
    const orderData = {
      contact_id: parseInt(contactId),
      products: products,
      redeem_points: parseFloat(shippingInfo.redeem_points || 0),
      shipping: {
        governarte: parseInt(shippingInfo.governarte),
        shipping_address: shippingInfo.shipping_address,
        shipping_charges: parseFloat(shippingInfo.shipping_charges || 0),
        delivered_to: shippingInfo.delivered_to,
        shipping_details: shippingInfo.shipping_details || "",
      },
      payments: [
        {
          // amount: cartTotal + shippingCharges, // أو 0 حسب منطق التطبيق
          amount: 0, // أو 0 حسب منطق التطبيق
          method: shippingInfo.payment_method || "cod", // استخدام طريقة الدفع المرسلة
        },
      ],
    };

    return {
      success: true,
      data: orderData,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

// دالة للتحقق من صحة البيانات الأساسية
export const validateOrderData = (contactId, shippingInfo) => {
  const errors = [];

  // التحقق من معرف المستخدم
  if (!contactId) {
    errors.push("معرف المستخدم مطلوب");
  }

  // التحقق من بيانات الشحن
  if (!shippingInfo) {
    errors.push("بيانات الشحن مطلوبة");
  } else {
    if (!shippingInfo.governarte) {
      errors.push("المحافظة مطلوبة");
    }
    if (!shippingInfo.shipping_address?.trim()) {
      errors.push("عنوان الشحن مطلوب");
    }
    if (!shippingInfo.delivered_to?.trim()) {
      errors.push("اسم المستلم مطلوب");
    }
  }

  // التحقق من السلة
  const cart = getCart();
  if (!cart || cart.length === 0) {
    errors.push("السلة فارغة");
  }

  return {
    isValid: errors.length === 0,
    errors: errors,
  };
};

// دالة للحصول على ملخص الطلب
export const getOrderSummary = () => {
  const cart = getCart();
  if (!cart || cart.length === 0) return null;

  const subtotal = parseFloat(getCartTotal());

  return {
    items: cart.map((item) => ({
      name: item.item_name,
      quantity: item.count,
      price: parseFloat(item.price),
    })),
    subtotal: subtotal.toFixed(2),
    itemsCount: cart.length,
  };
};

// دالة لحفظ قائمة المفضلة بالكامل
export const saveFavorites = (favorites) => {
  try {
    const storageKey = getStorageKey("favorites");
    localStorage.setItem(storageKey, JSON.stringify(favorites));
    triggerStorageEvent("favorites");
    return true;
  } catch (error) {
    console.error("Error saving favorites to localStorage:", error);
    return false;
  }
};

// دالة لحفظ السلة بالكامل (تُستخدم لمزامنة الأسعار)
export const saveCart = (cart) => {
  try {
    const storageKey = getStorageKey("cart");
    localStorage.setItem(storageKey, JSON.stringify(cart));
    triggerStorageEvent("cart");
    return true;
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
    return false;
  }
};
